import { bizGet, bizPost } from '../../shared/api/bizClient';
import type {
  MigrationActionFormValues,
  MigrationRunRecord,
  ProfileMigrationRecord,
  TenantRunActionFormValues,
} from './types';

const BASE_PATH = '/biz/admin/profile-migrations';

export async function listMigrations(): Promise<ProfileMigrationRecord[]> {
  return bizGet<ProfileMigrationRecord[]>(BASE_PATH);
}

export async function getMigration(id: string): Promise<ProfileMigrationRecord | null> {
  return bizGet<ProfileMigrationRecord>(`${BASE_PATH}/${id}`);
}

export async function listRuns(migrationId: string): Promise<MigrationRunRecord[]> {
  return bizGet<MigrationRunRecord[]>(`${BASE_PATH}/${migrationId}/runs`);
}

export async function applyMigrationAction(
  migrationId: string,
  values: MigrationActionFormValues,
): Promise<ProfileMigrationRecord> {
  return bizPost<ProfileMigrationRecord, MigrationActionFormValues>(
    `${BASE_PATH}/${migrationId}/action`,
    values,
  );
}

export async function applyTenantRunAction(
  migrationId: string,
  runId: string,
  values: TenantRunActionFormValues,
): Promise<MigrationRunRecord> {
  return bizPost<MigrationRunRecord, TenantRunActionFormValues>(
    `${BASE_PATH}/${migrationId}/runs/${runId}/action`,
    values,
  );
}
